import { map, pick } from 'lodash'

const transformToSaveChallengesArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, ['id', 'name', 'position']),
    position: index,
  }))

export default transformToSaveChallengesArgs
